import React, { Component } from 'react';
import Sticky from 'react-sticky-el';
import { Link as ScrollLink, scroller } from 'react-scroll';

class StickyNav extends Component {
	componentDidMount() {
		if (window.location.hash !== '') {
			scroller.scrollTo(window.location.hash.replace('#',''), {
				duration: 500,
				offset: -46,
				smooth: true,
				spy: true
			});
		}
	}

	handleClick(e) {
		global.dataLayer.push({
			event: 'Sub Nav',
			eventCategory: 'Sub Navigation',
			eventAction: global.location.pathname,
			eventLabel: e.currentTarget.textContent
		});
	}

	render() {
		return (
			<Sticky className="page-nav">
				<div className="row">
					<div className="col">
						<ul>
							<li>
								<ScrollLink
									activeClass="active"
									to="types-of-protection"
									spy={ true }
									smooth={ true }
									offset={ -46 }
									duration={ 500 }
									onSetActive={ this.handleSetActive }
									onClick={ e => this.handleClick(e) }
								>
									Types of Protection
								</ScrollLink>
							</li>
							<li>
								<ScrollLink
									activeClass="active"
									to="warranties-and-guarantees"
									spy={ true }
									smooth={ true }
									offset={ -46 }
									duration={ 500 }
									onSetActive={ this.handleSetActive }
									onClick={ e => this.handleClick(e) }
								>
									Warranties &amp; Guarantees
								</ScrollLink>
							</li>
							<li>
								<ScrollLink
									activeClass="active"
									to="security"
									spy={ true }
									smooth={ true }
									offset={ -46 }
									duration={ 500 }
									onSetActive={ this.handleSetActive }
									onClick={ e => this.handleClick(e) }
								>
									Security Features
								</ScrollLink>
							</li>
							<li>
								<ScrollLink
									activeClass="active"
									to="lock-types"
									spy={ true }
									smooth={ true }
									offset={ -46 }
									duration={ 500 }
									onSetActive={ this.handleSetActive }
									onClick={ e => this.handleClick(e) }
								>
									Lock Types
								</ScrollLink>
							</li>
							<li>
								<ScrollLink
									activeClass="active"
									to="organizational-features"
									spy={ true }
									smooth={ true }
									offset={ -46 }
									duration={ 500 }
									onSetActive={ this.handleSetActive }
									onClick={ e => this.handleClick(e) }
								>
									Organizational Features
								</ScrollLink>
							</li>
						</ul>
					</div>
				</div>
			</Sticky>
		);
	}
};

export default StickyNav;


// WEBPACK FOOTER //
// ./src/pages/learn/buyingGuide/StickyNav.js